/**
 * 管理UIモーダルの制御
 * ADMIN_UI_KEYS からチェックボックスを動的生成し、設定の保存/読み込みを行う
 */
import { ADMIN_UI_KEYS, getAdminSetting, setAdminSetting } from '../utils/adminUiSettings'

document.addEventListener('DOMContentLoaded', () => {
  const body = document.getElementById('adminUiModalBody')
  if (!body) return

  // ADMIN_UI_KEYSからチェックボックスを動的生成
  Object.entries(ADMIN_UI_KEYS).forEach(([key, def]) => {
    const div = document.createElement('div')
    div.className = 'form-check form-switch'
    const checked = getAdminSetting(key) ? 'checked' : ''
    div.innerHTML = `
      <input class="form-check-input" type="checkbox" role="switch" id="adminUi_${key}" ${checked}>
      <label class="form-check-label" for="adminUi_${key}">${def.label}</label>
    `
    body.appendChild(div)

    // チェックボックス変更時に設定を保存
    div.querySelector('input').addEventListener('change', (e) => {
      setAdminSetting(key, e.target.checked)
    })
  })
})
